/*=========================================================================================
  File Name: moduleReportMutations.js
  Description: Report Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	ADD_DOWNLOAD_REPORT(state, downloadReport) {
		state.downloads.unshift(downloadReport);
	},
	SET_DOWNLOAD_REPORTS(state, downloadReports) {
		state.downloads = downloadReports;
	},
	DELETE_DOWNLOAD_REPORT(state, process_id) {
		const ItemIndex = state.downloads.findIndex((p) => p.process_id === process_id);
		state.downloads.splice(ItemIndex, 1);
	},
	REMOVE_FILE_DOWNLOAD_REPORT(state, downloadReports) {
		const ItemIndex = state.downloads.findIndex((p) => p.process_id === downloadReports.process_id);
		const ItemIndexFile = state.downloads[ItemIndex].files.findIndex((p) => p.id === downloadReports.numFile);
		state.downloads[ItemIndex].files.splice(ItemIndexFile, 1);
		state.downloads[ItemIndex].num_files = state.downloads[ItemIndex].num_files - 1;
	},
	CLEAN_DOWNLOAD_REPORTS(state) {
		state.downloads = [];
	},
	SET_FILES_REPORT(state, files) {
		state.files = files;
	},
};
